import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import productData from '../data/productData';
import fallbackImage from '../assets/logo-placeholder.png';
import Magnifier from '../components/Magnifier';
import { LogIn } from 'lucide-react';


const ProductPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  const product = productData.find((p) => p.link === `/product/${slug}`);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  if (!product) {
    return (
      <div className="min-h-screen flex flex-col bg-white dark:bg-neutral-800 text-gray-800 dark:text-gray-200">
        <Navbar />
        <main className="flex-grow flex items-center justify-center">
          <p className="text-2xl font-bold">Product not found</p>
        </main>
        <Footer />
      </div>
    );
  }

  const images = product.images && product.images.length > 0 ? product.images : [fallbackImage];
  const mainImage = images[selectedImageIndex];

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-neutral-800 text-gray-800 dark:text-gray-200">
      <Navbar />
      <main className="flex-grow px-4 py-10 max-w-7xl mx-auto">
        {/* Grid responsive: 1 col mobil, 2 col md+ */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
          <div className="w-full max-w-full md:max-w-md mx-auto md:mx-0 flex flex-col">
            <div className="relative w-full max-w-md bg-white dark:bg-neutral-700 rounded-md overflow-hidden hover:ring-green hover:shadow-[0_0_25px_rgba(2,89,81,0.5)]">
              <Magnifier
                src={`/products/${mainImage}`}
                alt={product.title}
                zoomLevel={3}
                className="w-full h-auto object-contain"
              />
            </div>
            {/* Miniaturi imagini */}
            <div className="flex mt-4 gap-2 overflow-x-auto">
              {images.map((img, idx) => (
                <img
                  key={idx}
                  src={`/products/${img}`}
                  alt={`${product.title} ${idx + 1}`}

                  onClick={() => setSelectedImageIndex(idx)}
                  onError={(e) => {
                    e.currentTarget.src = fallbackImage;
                  }}
                  className={`w-20 h-20 sm:w-24 sm:h-24 object-cover rounded cursor-pointer transition
  hover:ring-2 hover:ring-green hover:shadow-[0_0_25px_rgba(0,255,0,0.5)]
  ${selectedImageIndex === idx ? 'ring-4 ring-green' : ''}`}
                />
              ))}
            </div>
          </div>


          {/* Detalii produs */}
          <div className="flex flex-col justify-start max-w-full">
            <h1 className="text-3xl font-bold mb-4">{product.title}</h1>
            <p className="text-lg mb-6">{product.description}</p>
            
            <div className="bg-blue-50 dark:bg-blue-900/30 border border-blue-200 dark:border-blue-600 rounded-lg p-4 mb-6">
  <p className="text-blue-800 dark:text-blue-300 text-sm font-medium mb-3">
    To see prices and place orders, please visit our main website:
  </p>
  <a
    href="https://felixdent.co.uk/products/"
    target="_blank"
    rel="noopener noreferrer"
    className="bg-gradient-to-r from-[#025951] to-emerald-500 text-white py-2 px-6 rounded-lg hover:from-emerald-600 hover:to-emerald-400 transition-all duration-300 inline-flex items-center font-medium"
  >
    <LogIn className="w-4 h-4 mr-2" />
    Visit FelixDent.co.uk
  </a>
</div>

          </div>
        </div>

        {/* Produse similare */}
<div className="mt-16">
  <h2 className="text-2xl font-bold mb-8 text-center">Related Products</h2>
  
  <div className="flex justify-center flex-wrap gap-4 w-full px-2 pb-20">
    {[...productData]
      .filter((p) => p.id !== product.id)
      .sort((a, b) => Math.abs(a.id - product.id) - Math.abs(b.id - product.id))
      .slice(0, 3)
      .map((related) => (
        <div
          key={related.id}
          onClick={() => navigate(related.link)}
          className="w-[100%] sm:w-[48%] md:w-[30%] bg-white dark:bg-neutral-700 rounded-lg shadow-md p-3 cursor-pointer hover:scale-105 transition-transform"
        >
          <img
            src={
              related.images && related.images.length > 0
                ? `/products/${related.images[0]}`
                : fallbackImage
            }
            onError={(e) => {
              e.currentTarget.src = fallbackImage;
            }}
            alt={`${related.title} preview`}
            className="w-full h-48 object-cover rounded mb-2"
          />
          <h3 className="text-md font-semibold text-center">{related.title}</h3>
        </div>
      ))}
  </div>
</div>

      </main>
      <Footer />
    </div>
  );
};

export default ProductPage;
